import { Days } from '@/core/types/utils'
import { AccommodationType } from '../rooms/rooms.types'

export enum RestrictionType {
  'Stay' = 'Stay',
  'End' = 'End',
  'Start' = 'Start',
}

export type Restriction = {
  id: string
  propertyId: string
  externalId: string | null
  externalCode: string | null
  baseRateId: string | null
  rateGroupId: string | null
  roomId: string | null
  rateId: string | null
  rate: {
    rateCode: string
    shortTitle: string
    id: string
  } | null
  rateGroup: {
    id: string
    rateGroupCode: string
    name: string
  } | null
  baseRate: {
    id: string
    rateCode: string
    shortTitle: string
  } | null
  room: {
    id: string
    roomCode: string
    shortTitle: string
  } | null
  days: Days[] | null
  accommodationType: AccommodationType | null
  startDate: string
  endDate: string
  minLeadIn: number | null
  maxLeadIn: number | null
  minLOS: number | null
  maxLOS: number | null
  minPrice: number | null
  maxPrice: number | null
  origin: string
  type: RestrictionType
  createdAt: string | null
  updatedAt: string | null
}
